import { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import EditorPublishButton from 'ContentEditorUI/components/shared/EditorPublishButton';
import BlogPostPublishConfirmModalBodyContent from '../components/BlogPostPublishConfirmModalBodyContent';
import usePublishActionHandlers, { useCMPPublishActionHandlers } from 'ContentEditorUI/components/publishing/hooks/usePublishActionHandlers';
import { usePublishLifecycleHandlers } from '../hooks/publishing';
// @ts-expect-error Untyped module
import { updateFocusedItem } from '../redux/actions/postFocusActions';
// @ts-expect-error Untyped module
import { openSocialComposerWithParams } from '../redux/actions/socialComposerActions';
import { getContentModelId, getContentModelPublicAccessRules } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getUnifiedPublishType } from 'ContentEditorUI/redux/selectors/publishSelectors';
import { getHasContentTypeLimitReducerAndExceededLimit } from 'ContentEditorUI/redux/selectors/limitSelectors';
import { getHasBlogPostsScheduleScope, getIsUngatedForCMPPublishing } from '../redux/selectors/authSelectors';
import { getSsoEnabledForBlogPostDomain } from '../redux/selectors/postSiteSettingsSelectors';
import { getPostWarningLabels, getPostErrorLabels
// @ts-expect-error Untyped module
} from '../redux/selectors/postWarningsAndSuggestionsSelectors';
import { getIsPublishEnabled, getIsUnpublishEnabled, getHasPermissionsToPublish, getCannotPublishOnActiveDomainReason
// @ts-expect-error Untyped module
} from '../redux/selectors/postPublishSelectors';
import { getHasExceededMlangBlogPostLimit, getIsOnlyOverBlogPostsLimit
// @ts-expect-error Untyped module
} from '../redux/selectors/blogLimitsSelectors';
// @ts-expect-error Untyped module
import { getDashboardUrl } from '../redux/selectors/urlSelectors';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { getHasContentManagementSavedViews } from 'ContentEditorUI/redux/selectors/authSelectors';
import { getPortalHasMembershipsAccess, getPortalIsUngatedForMembershipsPublishInfo } from '../redux/selectors/authSelectors';
import { getShouldShowSocialAutoPublish, getNotificationEmailsEnabled
// @ts-expect-error Untyped module
} from '../redux/selectors/postSettingsSelectors';
// @ts-expect-error Untyped module
import { getEnableGoogleAmpOutput } from '../redux/selectors/ampSelectors';
import { EMAIL_SENDING_ACKNOWLEDGEMENT_THRESHOLD } from 'ui-memberships-settings-lib/components/alerts/RegistrationEmailSendingAcknowledgement';
import { PublicAccessRuleTypes } from 'ui-memberships-settings-lib/constants/PublicAccessRuleTypes';
import { getMembershipsEmailSendAcknowledgementDisabledTooltipI18nKey } from 'ui-memberships-settings-lib/utils/tooltips';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import { useCurrentContentContext } from 'ContentEditorUI/utils/contentContextUtils';
import { ContentObjectTypes } from 'content-management-data-lib';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BlogPublishButtonContainer = () => {
  var _blogPostPublicAccess;
  const [unregisteredContactsCount, setUnregisteredContactsCount] = useState(0);
  const [isEmailSendingAcknowledgementChecked, setIsEmailSendingAcknowledgementChecked] = useState(false);
  const errors = useSelector(getPostErrorLabels);
  const warnings = useSelector(getPostWarningLabels);
  const canSchedule = useSelector(getHasBlogPostsScheduleScope);
  const publishEnabled = useSelector(getIsPublishEnabled);
  const unpublishEnabled = useSelector(getIsUnpublishEnabled);
  const hasExceededMlangBlogPostLimit = useSelector(getHasExceededMlangBlogPostLimit);
  const blogDashboardUrl = useSelector(getDashboardUrl);
  const tooltipOverride = useMemo(() => {
    if (hasExceededMlangBlogPostLimit) {
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "mLangBlogPostLimitExceededError",
        options: {
          blogDashboardUrl
        }
      });
    }
  }, [blogDashboardUrl, hasExceededMlangBlogPostLimit]);
  const hasExceededContentTypeLimit = useSelector(getHasContentTypeLimitReducerAndExceededLimit);
  const isOnlyOverBlogPostsLimit = useSelector(getIsOnlyOverBlogPostsLimit);
  const upgradeModalKey = isOnlyOverBlogPostsLimit ? 'cms-starter-blog-post-publish-button-editor' : 'blog-post-publish-button';
  const {
    openUpgradeModal
  } = useUpgradeModal(upgradeModalKey);
  const contentTypeHasSavedViews = useSelector(getHasContentManagementSavedViews);
  const contentId = useSelector(getContentModelId);
  const shouldUseCMPPublicationAPI = useSelector(getIsUngatedForCMPPublishing);
  const publishLifecycleHandlers = usePublishLifecycleHandlers();
  const {
    publish: publishWithCmp,
    unpublish: unpublishWithCmp,
    schedulePublishUnpublish
  } = useCMPPublishActionHandlers(Object.assign({}, publishLifecycleHandlers, {
    contentObjectType: ContentObjectTypes.BLOG_POST,
    objectId: contentId,
    shouldConvertCMPObjectToInstanceObject: false
  }));
  const {
    publish,
    unpublish
  } = usePublishActionHandlers(publishLifecycleHandlers);
  const dispatch = useDispatch();
  const shouldShowSocialAutoPublish = useSelector(getShouldShowSocialAutoPublish);
  const {
    getCurrentContentContext: getPostBodyValueAndOpenSocialComposer
  } = useCurrentContentContext('#hs_cos_wrapper_post_body', responseText => dispatch(openSocialComposerWithParams(responseText)));
  const extraDropdownActions = useMemo(() => {
    if (shouldShowSocialAutoPublish) {
      return [{
        id: 'social-options',
        label: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(UIIcon, {
            name: "social"
          }), /*#__PURE__*/_jsx("span", {
            children: "Social"
          })]
        }),
        onClick: () => {
          UsageTracker.trackEditorInteraction({
            action: 'Publish Dropdown Action',
            event: 'clicked-action--social-composer'
          });
          getPostBodyValueAndOpenSocialComposer();
        }
      }];
    }
    return [];
  }, [getPostBodyValueAndOpenSocialComposer, shouldShowSocialAutoPublish]);
  const notificationEmailsEnabled = useSelector(getNotificationEmailsEnabled);
  const enableGoogleAmpOutput = useSelector(getEnableGoogleAmpOutput);
  const unifiedPublishType = useSelector(getUnifiedPublishType);
  const hasPermissionsToPublish = useSelector(getHasPermissionsToPublish);
  const buttonTextKey = useMemo(() => {
    if (!hasPermissionsToPublish && !hasExceededContentTypeLimit) {
      return 'header.publishButton.notAuthorized.label';
    }
    return `header.publishButton.${unifiedPublishType}.label`;
  }, [hasExceededContentTypeLimit, hasPermissionsToPublish, unifiedPublishType]);
  const cannotPublishOnDomainReason = useSelector(getCannotPublishOnActiveDomainReason);
  const portalHasMembershipsAccess = useSelector(getPortalHasMembershipsAccess);
  const portalIsUngatedForMembershipsPublishInfo = useSelector(getPortalIsUngatedForMembershipsPublishInfo);
  const blogPostPublicAccessRules = useSelector(getContentModelPublicAccessRules);
  const ssoEnabledForBlogPostDomain = useSelector(getSsoEnabledForBlogPostDomain);
  const blogPostIsPublic = blogPostPublicAccessRules.length === 0 || blogPostPublicAccessRules[0].type === PublicAccessRuleTypes.PUBLIC;
  const blogPostHasAccessGroupsMembership = ((_blogPostPublicAccess = blogPostPublicAccessRules[0]) === null || _blogPostPublicAccess === void 0 ? void 0 : _blogPostPublicAccess.type) === PublicAccessRuleTypes.ACCESS_GROUP_MEMBERSHIP && !ssoEnabledForBlogPostDomain;
  const disabledForMissingEmailSendingAcknowledgement = blogPostHasAccessGroupsMembership && unregisteredContactsCount >= EMAIL_SENDING_ACKNOWLEDGEMENT_THRESHOLD && !isEmailSendingAcknowledgementChecked;
  const handleUnregisteredContactsCountFetchSuccess = count => {
    setUnregisteredContactsCount(count);
  };
  const handleEmailSendingAcknowledgementChange = checked => {
    setIsEmailSendingAcknowledgementChecked(checked);
  };
  return /*#__PURE__*/_jsx(EditorPublishButton, {
    errors: errors,
    warnings: warnings,
    canSchedule: canSchedule,
    publishEnabled: publishEnabled,
    unpublishEnabled: unpublishEnabled,
    buttonTextKey: buttonTextKey,
    updateFocusedItemAction: updateFocusedItem,
    tooltipOverride: tooltipOverride,
    lockedPublishButtonProps: {
      isLocked: hasExceededContentTypeLimit,
      onClickLocked: openUpgradeModal
    },
    schedulingOptionsModalProps: {
      dashboardUrl: blogDashboardUrl,
      allowBackdating: true,
      canScheduleUnpublish: false,
      contentTypeHasSavedViews
    },
    extraDropdownActions: extraDropdownActions,
    confirmPublishActionProps: {
      shouldConfirmPublishAction: notificationEmailsEnabled || !enableGoogleAmpOutput || shouldShowSocialAutoPublish || portalIsUngatedForMembershipsPublishInfo && portalHasMembershipsAccess && !blogPostIsPublic,
      publishConfirmModalBodyContent: /*#__PURE__*/_jsx(BlogPostPublishConfirmModalBodyContent, {
        isEmailSendingAcknowledgementChecked: isEmailSendingAcknowledgementChecked,
        onEmailSendingAcknowledgementChange: handleEmailSendingAcknowledgementChange,
        onUnregisteredContactsCountFetchSuccess: handleUnregisteredContactsCountFetchSuccess
      }),
      publishConfirmDisabled: disabledForMissingEmailSendingAcknowledgement,
      publishConfirmDisabledTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: getMembershipsEmailSendAcknowledgementDisabledTooltipI18nKey()
      })
    },
    publish: shouldUseCMPPublicationAPI ? publishWithCmp : publish,
    unpublish: shouldUseCMPPublicationAPI ? unpublishWithCmp : unpublish,
    schedulePublishUnpublish: shouldUseCMPPublicationAPI ? schedulePublishUnpublish : undefined,
    cannotPublishOnDomainReason: cannotPublishOnDomainReason,
    isNotAuthorizedToPublish: !hasPermissionsToPublish && !hasExceededContentTypeLimit,
    isUsingCMPPublish: shouldUseCMPPublicationAPI
  });
};
export default BlogPublishButtonContainer;